import React from "react";
import { Card, CardContent, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import styles from "../../styles/global-styles";

const usetSyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
    margin: theme.spacing(2, 4),
    height: 350,
  },
  divTitle: {
    margin: theme.spacing(2, 4),
  },
  link: styles.link,
}));

const DashboardCard = ({ icon, title, subtitle, url, select, children }) => {
  const classes = usetSyles();
  return (
    <React.Fragment>
      <Card className={classes.root} style={{ overflow: "auto" }}>
        <div
          className={classes.divTitle}
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          {icon}
          <Typography variant="h5">
            <Box ml={3}>{title}</Box>
          </Typography>
          <Typography variant="body1">
            <Link to={url} className={classes.link} style={{ marginLeft: 20 }}>
              {subtitle}
            </Link>
          </Typography>
          {select}
        </div>

        <CardContent>{children}</CardContent>
      </Card>
    </React.Fragment>
  );
};

DashboardCard.propTypes = {
  url: PropTypes.string,
};

DashboardCard.defaultProps = {
  url: "",
};

export default DashboardCard;
